<template>
  <div
    class="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12"
  >
    <div class="w-full max-w-sm">
      <div class="rounded-2xl bg-white p-8 shadow-xl">
        <div class="mb-8 text-center">
          <img
            src="/assets/trellis-logo.svg"
            alt="Trellis"
            class="mx-auto mb-4 h-10 w-auto"
          />
          <h1 class="text-xl font-semibold text-gray-900">ID Verification</h1>
          <p class="mt-2 text-sm text-gray-500">
            Enter the code shown on the screen to verify your identity.
          </p>
        </div>

        <form class="space-y-6" @submit.prevent="submit">
          <AppInput
            ref="codeInput"
            v-model="form.verification_code"
            label="Verification Code"
            type="text"
            inputmode="numeric"
            maxlength="6"
            placeholder="000000"
            :error="form.errors.verification_code"
            required
            autocomplete="off"
            class="text-center"
          />

          <AppButton type="submit" :loading="form.processing" class="w-full">
            Verify
          </AppButton>
        </form>
      </div>

      <p class="mt-4 text-center text-xs text-gray-400">
        Verifying for {{ participantName }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useForm } from "@inertiajs/vue3"
import { onMounted } from "vue"

import AppButton from "../../components/ui/AppButton.vue"
import AppInput from "../../components/ui/AppInput.vue"

const props = defineProps<{
  token: string
  participantName: string
  status: string
}>()

const form = useForm({
  verification_code: "",
})

function submit() {
  form.post(`/verification/${props.token}/verify`)
}

onMounted(() => {
  document
    .querySelector<HTMLInputElement>('input[inputmode="numeric"]')
    ?.focus()
})

defineOptions({ layout: false })
</script>
